var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinpointIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "artwork",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.5,6s-6.1,0-8.2,5.6c-2.8,7.3,8.2,18.6,8.2,18.6,0,0,11-11.3,8.2-18.6s-8.2-5.6-8.2-5.6",
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 14.7,
    r: 3.9,
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 32.8,
    r: 1.4,
    style: {
      fill: "#0194d3"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinpointIcon);
export default __webpack_public_path__ + "static/media/pinpoint-icon.29a4c6654ea814c774b2bedb7580c8c5.svg";
export { ForwardRef as ReactComponent };